import React, { useState, useEffect, useRef } from 'react';
import '../style/brand.css';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

// Import all brand images
import logo1 from '../../images/partner_1.png'; // Pepsi
import logo2 from '../../images/partner_2.png'; // Ideas by Gul Ahmed
import logo3 from '../../images/partner_3.png'; // J. Junaid Jamshed
import logo4 from '../../images/partner_4.png'; // Soul Fest
import logo5 from '../../images/partner_5.png';// KIA
import logo6 from '../../images/partner_6.png'; // OD (Donut Brand)
import logo7 from '../../images/partner_7.png'; // Edenrobe
import logo8 from '../../images/partner_8.png';  // Jumbo Jump
import logo9 from '../../images/partner_9.jpeg';// Sting
import logo10 from '../../images/partner_10.jpeg'; 
import logo11 from '../../images/partner_11.png'; // Packages Mall
import logo12 from '../../images/partner_12.png'; // The Entertainer Toy Shop
import logo13 from '../../images/partner_13.png'; // Brim
import logo14 from '../../images/partner_14.jpeg'; // Crown Solar Energy
import logo15 from '../../images/partner_15.png'; // SA Gardens
import logo16 from '../../images/partner_16.png'; // Narkin's
import logo17 from '../../images/partner_17.png'; // IKONIC
import logo18 from '../../images/partner_18.jpeg'; // Jabchaho
import logo19 from '../../images/partner_19.png'; // Stone Oven
import logo20 from '../../images/partner_20.png'; // Sketchers
import logo21 from '../../images/partner_21.jpeg'; // Contra
import logo22 from '../../images/partner_22.png'; // Fortress Square
import logo23 from '../../images/partner_23.png'; // Scent Stories
import logo24 from '../../images/partner_24.png'; // Burger O'Clock
import logo25 from '../../images/partner_25.jpeg'; // UCE Up Country Enclousars
import logo26 from '../../images/partner_26.jpeg'; // SG SuperGame
import logo27 from '../../images/partner_27.jpeg'; // Metro
import logo28 from '../../images/partner_28.png'; // Alpha Bolt
import logo29 from '../../images/partner_29.png'; // GameStop
import logo30 from '../../images/partner_30.png'; // Paramount
import BrandMarquee from './logobar';
// import logo31 for RSM (if available)

// Brand data with detailed descriptions
const featuredBrands = [
    {
        id: 1,
        name: "Pepsi",
        logo: logo1,
        category: "VFX & Hyperlapse",
        description: "We crafted a high-energy hyperlapse commercial for Pepsi that captures the vibrant energy of youth. The video features seamless VFX transitions, dynamic color grading, and slow-motion pour shots that make every bubble pop. Our team utilized advanced compositing techniques to create a refreshing visual experience that perfectly aligns with Pepsi's 'Youngistan' vibe. The commercial showcases our expertise in product cinematography with liquid simulations and particle effects that bring the beverage to life.",
        deliverables: ["Hyperlapse Sequences", "VFX Compositing", "Color Grading", "Product Cinematography"]
    },
    {
        id: 2,
        name: "Ideas by Gul Ahmed",
        logo: logo2,
        category: "Fashion Cinematography & VFX",
        description: "For Ideas by Gul Ahmed, we produced a stunning fashion film highlighting their latest textile collection. The video features ethereal fabric simulations, dreamy slow-motion sequences, and VFX-enhanced lighting that makes each fabric texture come alive. We incorporated subtle particle effects to represent the craftsmanship behind each design. The result is a cinematic masterpiece that elevates traditional textile marketing into contemporary visual art, showcasing the intricate patterns and luxurious feel of their fabrics.",
        deliverables: ["Fashion Cinematography", "Fabric Simulations", "Color Grading", "Particle Effects"]
    },
    {
        id: 3,
        name: "J. Junaid Jamshed",
        logo: logo3,
        category: "Fashion & Lifestyle VFX",
        description: "Our collaboration with J. Junaid Jamshed resulted in a sophisticated fashion film that merges traditional elegance with modern visual effects. We employed advanced color grading techniques to enhance the rich textures of their fabric collections. The video includes ethereal transitions, light leak effects, and subtle VFX elements that create a dreamlike atmosphere around their apparel. Our speed ramping techniques highlight the fluid motion of their designs, making each garment appear to dance on screen.",
        deliverables: ["Fashion VFX", "Speed Ramping", "Color Grading", "Light Leak Effects"]
    },
    // {
    //     id: 4,
    //     name: "Futur Menus",
    //     logo: logo4,
    //     category: "3D CGI & Food Cinematography",
    //     description: "For Futur Menus, we created a mouth-watering CGI-rendered food commercial that blurs the line between reality and animation. Using advanced 3D modeling techniques, we reconstructed their signature dishes with photorealistic precision. The video features dynamic camera movements through digital kitchens, particle effects representing steam and freshness, and hyper-realistic food textures. Our VFX team added subtle animations to ingredients, making them appear to dance and flow, creating an unforgettable visual feast.",
    //     deliverables: ["3D CGI Modeling", "Food Cinematography", "Particle Effects", "Photorealistic Rendering"]
    // },
    {
        id: 4,
        name: "Soul Fest",
        logo: logo4,
        category: "Event Hyperlapse & VFX",
        description: "Soul Fest's promotional video was transformed using our signature hyperlapse techniques combined with cinematic VFX. We captured the festival's energy through time-lapse sequences that transition seamlessly into slow-motion crowd shots. Our team added ethereal light effects, particle simulations representing musical energy, and dynamic color grading that pulses with the beat. The video captures the soul of the festival experience, from sunrise setups to electrifying night performances.",
        deliverables: ["Event Hyperlapse", "Time-lapse", "Particle Simulations", "Dynamic Color Grading"]
    },
    {
        id: 5,
        name: "KIA",
        logo: logo5,
        category: "Automotive CGI & VFX",
        description: "Our automotive masterpiece for KIA showcases their vehicles through advanced CGI rendering and practical cinematography fusion. We created hyper-realistic 3D models of KIA's latest models, placing them in both studio-perfect conditions and real-world environments. The video features complex camera tracking, seamless vehicle matte painting, and VFX-enhanced reflections that make the cars gleam. Our speed ramping techniques highlight the vehicles' design lines and performance capabilities.",
        deliverables: ["Automotive CGI", "3D Modeling", "Camera Tracking", "Matte Painting"]
    },
    {
        id: 6,
        name: "OD (Donut Brand)",
        logo: logo6,
        category: "Food VFX & Product Cinematography",
        description: "OD's donuts came to life through our delectable food cinematography and playful VFX. We captured every sprinkle and glaze with macro photography techniques, then enhanced the footage with animated sprinkles that dance around the donuts. The video features fluid simulations of chocolate drizzles, particle effects representing sugar dust, and seamless transitions between different donut varieties. Our color grading makes each donut look irresistibly fresh and appetizing.",
        deliverables: ["Food VFX", "Macro Photography", "Fluid Simulations", "Particle Effects"]
    },
    {
        id: 7,
        name: "Edenrobe",
        logo: logo7,
        category: "Fashion Cinematography & VFX",
        description: "Edenrobe's fashion campaign was elevated with our signature blend of elegant cinematography and subtle VFX enhancements. We created flowing fabric simulations that catch light perfectly, enhanced by ethereal particle effects. The video transitions between studio shots and outdoor locations using seamless VFX composites. Our color grading emphasizes the rich textures of Eastern and Western fusion wear, creating a sophisticated visual narrative that appeals to modern fashion consumers.",
        deliverables: ["Fashion VFX", "Fabric Simulations", "Seamless Transitions", "Color Grading"]
    },
    {
        id: 8,
        name: "Jumbo Jump",
        logo: logo8,
        category: "Action VFX & Speed Ramping",
        description: "Jumbo Jump's high-energy brand video features our signature action cinematography and VFX. We utilized advanced speed ramping techniques to capture every jump in stunning detail, then enhanced the footage with particle effects and dynamic motion graphics. The video transitions between slow-motion acrobatics and hyper-lapse sequences of the facility. Our team added glow effects and light trails that follow each jumper, creating an electrifying visual experience.",
        deliverables: ["Action VFX", "Speed Ramping", "Motion Graphics", "Light Trails"]
    },
    {
        id: 9,
        name: "Sting Energy",
        logo: logo9,
        category: "VFX & Particle Simulations",
        description: "Sting Energy's commercial pulses with energy thanks to our advanced particle simulations and VFX work. We created explosive energy effects that surround the product, using custom particle systems that simulate electrical currents and power surges. The video features seamless transitions between live-action and CGI elements, with dynamic color grading that shifts from cool to warm tones. Our team added glitch effects and motion blur that perfectly capture the drink's energizing essence.",
        deliverables: ["Particle Simulations", "VFX Compositing", "CGI Integration", "Glitch Effects"]
    },
    {
        id: 10,
        name: "Packages Mall",
        logo: logo10,
        category: "Architectural Hyperlapse & VFX",
        description: "Packages Mall's grandeur was captured through our architectural hyperlapse techniques and cinematic VFX. We created smooth day-to-night transitions showing the mall's transformation, with VFX-enhanced lighting that highlights its modern design. The video features complex camera moves through the mall's corridors, enhanced with subtle particle effects and glow. Our team added digital crowds and atmospheric effects to showcase the mall's vibrant shopping experience.",
        deliverables: ["Architectural Hyperlapse", "Day-to-Night Transitions", "Atmospheric VFX", "Digital Compositing"]
    },
    {
        id: 11,
        name: "The Entertainer Toy Shop",
        logo: logo11,
        category: "VFX & Motion Graphics",
        description: "The Entertainer came alive through our playful VFX and motion graphics work. We created animated toy characters that interact with real-world footage, using advanced tracking and compositing techniques. The video features colorful particle effects, whimsical transitions, and kinetic typography that appeals to children and parents alike. Our team added 3D animated elements that pop out of toy boxes, creating magical moments throughout the commercial.",
        deliverables: ["Character Animation", "Motion Graphics", "3D Compositing", "Kinetic Typography"]
    },
    {
        id: 12,
        name: "Brim",
        logo: logo12,
        category: "Product VFX & Cinematography",
        description: "Brim's sophisticated brand video showcases our premium product cinematography and subtle VFX enhancements. We captured their products with meticulous lighting, then added ethereal glow effects and smooth transitions between shots. The video features elegant particle effects representing the brand's essence, with color grading that emphasizes premium quality. Our team created seamless composites that highlight product details while maintaining a clean, modern aesthetic.",
        deliverables: ["Product VFX", "Glow Effects", "Seamless Transitions", "Color Grading"]
    },
    {
        id: 13,
        name: "Crown Solar Energy",
        logo: logo13,
        category: "3D CGI & Environmental VFX",
        description: "Crown Solar Energy's vision was realized through our 3D CGI environmental visualizations. We created photorealistic solar farm animations showing energy generation, with particle effects representing clean energy flow. The video transitions between real-world installations and CGI-rendered future expansions. Our team added atmospheric effects, accurate lighting simulations, and dynamic cloud movements that showcase the beauty of renewable energy technology.",
        deliverables: ["3D CGI", "Environmental VFX", "Particle Simulations", "Atmospheric Effects"]
    },
    {
        id: 14,
        name: "SA Gardens",
        logo: logo14,
        category: "Real Estate Hyperlapse & VFX",
        description: "SA Gardens' luxury real estate project was showcased through our hyperlapse cinematography and VFX enhancements. We created smooth property walkthroughs enhanced with day-to-night transitions and seasonal changes. The video features VFX-enhanced landscaping, digital sky replacements, and particle effects that bring the gardens to life. Our team added virtual furniture and decor to help potential buyers visualize the spaces, creating compelling sales content.",
        deliverables: ["Real Estate Hyperlapse", "Virtual Staging", "Sky Replacements", "Day-to-Night Transitions"]
    },
    {
        id: 15,
        name: "Narkin's",
        logo: logo15,
        category: "Food Cinematography & VFX",
        description: "Narkin's culinary delights were captured through our mouth-watering food cinematography and appetizing VFX. We employed macro photography techniques to capture every detail, then added subtle steam simulations and particle effects representing freshness. The video features smooth transitions between ingredients and finished dishes, with color grading that makes every dish pop. Our team created animated recipe sequences that showcase Narkin's signature dishes in an engaging, educational format.",
        deliverables: ["Food VFX", "Macro Photography", "Steam Simulations", "Recipe Animation"]
    },
    {
        id: 16,
        name: "IKONIC PROFESSIONAL",
        logo: logo16,
        category: "Product VFX & Beauty Cinematography",
        description: "IKONIC PROFESSIONAL's beauty tools were elevated through our elegant product cinematography and precise VFX. We captured their styling tools with stunning macro photography, then added ethereal light effects and smooth transitions between products. The video features particle effects representing hair styling magic, with color grading that emphasizes the premium quality. Our team created before-and-after transformations enhanced with subtle VFX that showcase the tools' effectiveness.",
        deliverables: ["Beauty VFX", "Macro Photography", "Light Effects", "Product Transformations"]
    },
    {
        id: 17,
        name: "Jabchaho",
        logo: logo17,
        category: "Motion Graphics & UI Animation",
        description: "Jabchaho's digital platform was brought to life through our dynamic motion graphics and UI animations. We created smooth app interface animations that showcase the user journey, with kinetic typography explaining key features. The video transitions between real-world usage scenarios and digital interface animations, using seamless compositing techniques. Our team added particle effects and glow highlights that emphasize the platform's ease of use and modern design.",
        deliverables: ["Motion Graphics", "UI Animation", "Kinetic Typography", "App Showcase"]
    },
    {
        id: 18,
        name: "Stone Oven",
        logo: logo18,
        category: "Food Cinematography & VFX",
        description: "Stone Oven's artisanal pizzas were captured through our cinematic food photography and appetizing VFX. We filmed the entire pizza-making process with dynamic camera movements, then enhanced the footage with rising steam simulations and cheese pull animations. The video features macro shots of ingredients with subtle particle effects representing freshness, and color grading that makes every pizza look perfectly baked. Our team created an irresistible visual journey from dough to delicious.",
        deliverables: ["Food VFX", "Steam Simulations", "Macro Photography", "Cooking Process"]
    },
    {
        id: 19,
        name: "Skechers",
        logo: logo19,
        category: "Footwear VFX & Action Cinematography",
        description: "Skechers' footwear line was showcased through our dynamic action cinematography and product VFX. We captured the shoes in motion using advanced tracking techniques, then added speed lines and motion blur effects that emphasize comfort and performance. The video transitions between lifestyle shots and product details with seamless VFX composites. Our team created 3D rotations and material highlights that showcase the shoes' design and technology.",
        deliverables: ["Footwear VFX", "Action Tracking", "3D Product Rotations", "Motion Effects"]
    },
    {
        id: 20,
        name: "Contra",
        logo: logo20,
        category: "Streetwear VFX & Urban Cinematography",
        description: "Contra's streetwear collection was captured through our urban cinematography and edgy VFX. We filmed in gritty city locations then enhanced the footage with graffiti-style motion graphics and particle effects. The video features smooth transitions between different outfits, with color grading that emphasizes the brand's bold aesthetic. Our team added glitch effects and urban light leaks that perfectly complement the streetwear vibe.",
        deliverables: ["Streetwear VFX", "Urban Cinematography", "Glitch Effects", "Motion Graphics"]
    },
    {
        id: 21,
        name: "Fortress Square",
        logo: logo21,
        category: "Real Estate Hyperlapse & Architectural VFX",
        description: "Fortress Square's commercial real estate project was visualized through our architectural hyperlapse and VFX expertise. We created dynamic day-to-night transitions showing the building's transformation, with VFX-enhanced lighting that highlights modern architecture. The video features smooth camera moves through the property, enhanced with digital crowds and atmospheric effects. Our team added virtual retail spaces and signage to help potential tenants visualize the opportunities.",
        deliverables: ["Architectural VFX", "Real Estate Hyperlapse", "Virtual Staging", "Atmospheric Effects"]
    },
    {
        id: 22,
        name: "Scent Stories",
        logo: logo22,
        category: "Fragrance VFX & Artistic Cinematography",
        description: "Scent Stories' perfume collection was brought to life through our artistic fragrance cinematography and ethereal VFX. We created visual representations of scents using particle simulations and fluid animations that dance around the bottles. The video features dreamlike transitions between different fragrances, with color grading that matches each scent's personality. Our team added light leaks, lens flares, and subtle sparkle effects that capture the essence of luxury perfumery.",
        deliverables: ["Fragrance VFX", "Particle Simulations", "Fluid Animations", "Artistic Lighting"]
    },
    {
        id: 23,
        name: "Burger O'Clock",
        logo: logo23,
        category: "Food VFX & Cinematography",
        description: "Burger O'Clock's gourmet burgers were captured through our irresistible food cinematography and delicious VFX. We filmed the burger assembly with dynamic angles, then added cheese pull animations and steam simulations. The video features macro shots of ingredients with particle effects representing freshness, and color grading that makes every burger look perfectly charred. Our team created an appetizing visual journey that captures the brand's 'anytime' appeal.",
        deliverables: ["Food VFX", "Steam Simulations", "Macro Photography", "Burger Assembly"]
    },
    {
        id: 24,
        name: "UCE Up Country Enclousars",
        logo: logo24,
        category: "Lifestyle VFX & Brand Cinematography",
        description: "UCE's premium lifestyle brand was showcased through our elegant cinematography and refined VFX. We captured their products in natural settings, then added subtle atmospheric effects and smooth transitions. The video features soft focus techniques enhanced with particle effects representing their brand essence. Our color grading emphasizes the natural, organic quality of their products while maintaining a sophisticated aesthetic that appeals to discerning customers.",
        deliverables: ["Lifestyle VFX", "Atmospheric Effects", "Natural Cinematography", "Brand Storytelling"]
    },
    {
        id: 25,
        name: "SG SuperGame",
        logo: logo25,
        category: "Gaming VFX & Motion Graphics",
        description: "SG SuperGame's gaming brand was energized through our dynamic gaming VFX and motion graphics. We created animated game elements that interact with real-world footage, using advanced compositing techniques. The video features particle effects representing power-ups, glitch transitions between levels, and kinetic typography explaining features. Our team added 3D animated characters and environments that showcase the gaming experience.",
        deliverables: ["Gaming VFX", "Motion Graphics", "3D Animation", "Particle Effects"]
    },
    {
        id: 26,
        name: "Metro",
        logo: logo26,
        category: "Retail VFX & Commercial Cinematography",
        description: "Metro's retail experience was captured through our commercial cinematography and dynamic VFX. We filmed their stores with smooth tracking shots, then added digital signage animations and customer flow visualizations. The video features product highlights enhanced with subtle glow effects and smooth transitions between departments. Our color grading emphasizes the vibrant retail environment while maintaining a professional, clean aesthetic.",
        deliverables: ["Retail VFX", "Commercial Cinematography", "Digital Signage", "Product Highlights"]
    },
    {
        id: 27,
        name: "Alpha Bolt",
        logo: logo27,
        category: "Sports VFX & Action Cinematography",
        description: "Alpha Bolt's athletic brand was energized through our high-octane sports cinematography and explosive VFX. We captured athletes in motion using advanced tracking, then added speed lines, energy effects, and particle simulations. The video transitions between slow-motion action shots and fast-paced sequences with seamless VFX. Our team created 3D product reveals and dynamic typography that captures the brand's competitive spirit.",
        deliverables: ["Sports VFX", "Action Tracking", "Energy Effects", "3D Product Reveals"]
    },
    {
        id: 28,
        name: "GameStop",
        logo: logo28,
        category: "Gaming VFX & Retail Cinematography",
        description: "GameStop's gaming retail experience was brought to life through our fusion of retail cinematography and gaming VFX. We filmed their stores with dynamic camera moves, then added animated game characters interacting with real-world products. The video features particle effects representing gaming energy, glitch transitions between departments, and motion graphics highlighting promotions. Our color grading creates an immersive gaming atmosphere throughout the retail space.",
        deliverables: ["Gaming VFX", "Retail Cinematography", "Character Integration", "Motion Graphics"]
    },
    {
        id: 29,
        name: "Paramount",
        logo: logo29,
        category: "Corporate VFX & Brand Cinematography",
        description: "Paramount's corporate brand was elevated through our sophisticated business cinematography and professional VFX. We captured their operations with cinematic quality, then added subtle data visualizations and smooth transitions between departments. The video features animated infographics, particle effects representing business growth, and color grading that conveys trust and professionalism. Our team created a compelling corporate narrative that showcases Paramount's industry leadership.",
        deliverables: ["Corporate VFX", "Data Visualization", "Infographics", "Brand Storytelling"]
    },
    {
        id: 30,
        name: "RSM Home & Developers",
        logo: logo30,
        category: "Real Estate VFX & Architectural Visualization",
        description: "RSM Home & Developers' real estate projects were visualized through our architectural VFX and property cinematography. We created stunning day-to-night transitions showing their developments, with VFX-enhanced landscaping and lighting. The video features smooth flythroughs of properties, enhanced with virtual furniture and atmospheric effects. Our team added digital crowds and lifestyle elements that help potential buyers envision living in RSM's spaces.",
        deliverables: ["Real Estate VFX", "Architectural Visualization", "Virtual Staging", "Flythroughs"]
    }
];

const BrandsSection = () => {
    const [activeBrand, setActiveBrand] = useState(0);
    const [isAutoPlaying, setIsAutoPlaying] = useState(true);
    const autoPlayRef = useRef(null);

    const nextBrand = () => {
        setActiveBrand((prev) => (prev + 1) % featuredBrands.length);
    };

    const prevBrand = () => {
        setActiveBrand((prev) => (prev - 1 + featuredBrands.length) % featuredBrands.length);
    };

    useEffect(() => {
        if (isAutoPlaying) {
            autoPlayRef.current = setInterval(nextBrand, 8000); // 8 seconds for reading descriptions
        }
        return () => {
            if (autoPlayRef.current) {
                clearInterval(autoPlayRef.current);
            }
        };
    }, [isAutoPlaying]);

    // Pause autoplay on hover
    const handleMouseEnter = () => setIsAutoPlaying(false);
    const handleMouseLeave = () => setIsAutoPlaying(true);

    return (
        <section className="fx-brands-section">
            <div className="fx-brands-container">
                {/* Space-Themed Animated Header */}
                <div className="fx-brands-header">
                     <div className="fx-header-background">
                    <div className="fx-laser-ray fx-ray-1"></div>
                    <div className="fx-laser-ray fx-ray-2"></div>
                    <div className="fx-laser-ray fx-ray-3"></div>
                    <div className="fx-laser-ray fx-ray-4"></div>
                    <div className="fx-laser-ray fx-ray-5"></div>
                    <div className="fx-laser-ray fx-ray-6"></div>
                    <div className="fx-laser-ray fx-ray-7"></div>
                    <div className="fx-laser-ray fx-ray-8"></div>
                    <div className="fx-grid-pattern"></div>
                    <div className="fx-pulse-effect"></div>
                </div>
                    <h2 className="fx-brands-title">Brands We've Worked With</h2>
                    <p className="fx-brands-subtitle">Trusted by industry leaders worldwide</p>
                </div>
                
                {/* Featured Brand Slider */}
                <div 
                    className="fx-featured-brands"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    <div className="fx-brand-slider">
                        <button className="fx-slider-btn fx-prev-btn" onClick={prevBrand}>
                            <FaChevronLeft />
                        </button>
                        
                        <div className="fx-brand-card">
                            <div className="fx-brand-image-wrapper">
                                <div className="fx-brand-image">
                                    <img 
                                        src={featuredBrands[activeBrand].logo} 
                                        alt={featuredBrands[activeBrand].name}
                                    />
                                </div>
                                <div className="fx-brand-category-tag">
                                    {featuredBrands[activeBrand].category}
                                </div>
                            </div>
                            <div className="fx-brand-content">
                                <h3 className="fx-brand-name">{featuredBrands[activeBrand].name}</h3>
                                <p className="fx-brand-desc">{featuredBrands[activeBrand].description}</p>
                                <div className="fx-brand-deliverables">
                                    {featuredBrands[activeBrand].deliverables.map((item, index) => (
                                        <span key={index} className="fx-deliverable-tag">{item}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                        
                        <button className="fx-slider-btn fx-next-btn" onClick={nextBrand}>
                            <FaChevronRight />
                        </button>
                    </div>
                    
                    <div className="fx-slider-indicators">
                        {featuredBrands.map((_, index) => (
                            <button
                                key={index}
                                className={`fx-indicator ${index === activeBrand ? 'active' : ''}`}
                                onClick={() => setActiveBrand(index)}
                            />
                        ))}
                    </div>
                </div>
            </div>
            
            <div>
                <BrandMarquee />            
            </div>
        </section>
    );
};

export default BrandsSection;